// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"qH-z","heading":"rH-z","cardOverride":"sH-z"};